import moment from 'moment'

import { ApiClient } from '../../common/api/apiClient'
import { PlannerName } from '../../common/enums/PlannerNameEnum'
import { IMix } from '../types/IMix'
import IMixSkuUpdate from '../types/IMixSkuUpdate'
import IMixStatusUpdate from '../types/IMixStatusUpdate'
import { IForecastReason } from '../types/IForecastReason'

const getForecastReasons = async (
  apiClient: ApiClient,
): Promise<IForecastReason[]> =>
  await apiClient.get<IForecastReason[]>(PlannerName.Bakery, `mix/reasons`)

const getMixes = async (
  apiClient: ApiClient,
  storeId: number,
  planDate: Date,
): Promise<IMix[]> =>
  await apiClient.get<IMix[]>(
    PlannerName.Bakery,
    `mix/${storeId}/${moment(planDate).format('YYYY-MM-DD')}/0`,
  )

const getMixSkus = async (
  apiClient: ApiClient,
  storeId: number,
  planDate: Date,
  mixId: number,
): Promise<IMix[]> =>
  await apiClient.get<IMix[]>(
    PlannerName.Bakery,
    `mix/${storeId}/${moment(planDate).format('YYYY-MM-DD')}/${mixId}`,
  )

const updateMixStatus = async (
  apiClient: ApiClient,
  planId: number,
  mixId: number,
  mixStatusStageId: number,
  mixSkuUpdateList: IMixSkuUpdate[],
  rowVersion: string,
) => {
  const request: IMixStatusUpdate = {
    mixId,
    mixStatusStageId,
    planId,
    rowVersion,
    updateMixSkus: mixSkuUpdateList,
  }

  const body = JSON.stringify(request)
  return await apiClient.post(PlannerName.Bakery, 'mix/updateMixStatus', body)
}

const updateMixSkus = async (
  apiClient: ApiClient,
  mixId: number,
  mixSkuUpdateList: IMixSkuUpdate[],
) => {
  const body = JSON.stringify(mixSkuUpdateList)

  return await apiClient.post(
    PlannerName.Bakery,
    `mix/updateMixSku/${mixId}`,
    body,
  )
}

export {
  getForecastReasons,
  getMixes,
  getMixSkus,
  updateMixSkus,
  updateMixStatus,
}
